import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbNavContent } from '@ng-bootstrap/ng-bootstrap';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { NgForm, FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { RequirementService } from 'src/app/services/requirement.service';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { SendingIdService } from 'src/app/services/sending-id.service';
import { Note } from '../../model/note.model';
import { SendingUseridService } from 'src/app/services/sending-userid.service';
//import { NotesValidator } from './validation/notes.validator';
import { UsersService } from '@services/users.service';
import { User } from '@app/docuvision/models/user.model';
import "quill-mention";
import Quill from 'quill';


export interface Options {
  multiple: boolean;
  width: string;
  tags: boolean;
}


@Component({
    selector: 'app-batch-assigment-user',
    templateUrl: './batch.assigment.user.component.html',
    styleUrls: ['./batch.assigment.user.component.scss'],
    standalone: false
})

export class BatchAssigmentUserComponent implements OnInit {
	@Output() insertNote = new EventEmitter<boolean>();
	@Input() requirementIds: Array<number>;
	@Input() edicion: boolean;
	@Input() path: string;
	@Input() typeId: string;

  isCheckbox: boolean = true;
	usersSubscribers: Array<any>;
	errorMessage: string = '';
	successMessage: string = '';
	private _success = new Subject<string>();
	private _error = new Subject<string>();
	showTableAlert: boolean = false;
	loading: boolean = false;
	sentData: boolean = false;
	sentUserId: number;
  public options: Options;
  // New Form
	assigmentForm: FormGroup;
	submitted: boolean = false;
	//notes_validation_messages = NotesValidator.NOTES_VALIDATION_MESSAGES;
  users: User[] = [];
  mappedUsers:any;
  multipleMultiSelect: string;



	constructor(
		public activeModal: NgbActiveModal,
		public _requirements: RequirementService,
		private formBuilder: FormBuilder,
		private sendUserIdServ: SendingUseridService,
    public usersService: UsersService,
    private modalService: NgbModal,
	) {

      this.options = {
        width: '100%',
        multiple: false,
        tags: true
      };
   }






	ngOnInit() {

		this.sendUserIdServ.currentMessage.subscribe(id => this.sentUserId = id);
		this.assigmentForm = this.formBuilder.group({
      idsUsers: ['', Validators.required]
		});


    this.usersService.getUsers().subscribe(response => {
      this.mappedUsers = response['result'].map(x => {
          return {
            id: x.id,
            text: x.name
          };
        });
    });

    this.messageSubmitForm();



	}



  closeModal() {
		this.activeModal.close('Modal Closed');
	}
	//Form Alerts
	submitForm(form: NgForm) {

	}
	retrieveCollab(event) {

	}

	messageSubmitForm() {

	}

	get f() { return this.assigmentForm.controls; }
	add() {


	}

	create() {

	}


	reiniciarFormulario() {
	}
	obtenerPatchNote(data) {

	}

	changeObject(notes: Note) {

	}

  onSelectionChanged($event){

  }


}
